import Axios from "../../../../api/axios/Axios";

export const getAlbumGallery = (albumTag, signal) =>
  Axios.get(`/api/albums/shared/${encodeURIComponent(albumTag)}`, { signal });
